define.alias("shared/components/shared/ui/navigation-arrows", "preview-grid/components/shared/ui/navigation-arrows");